import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FormFieldsContainer } from '../../../../Form'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import { RequestEditStatusModalStatusField } from '../../../RequestEditStatusModal'
import {
  ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS,
  QA_NAME_ATTACH_SERVICE_REQUESTS_STATUS_MODAL_CHECKBOX,
} from '../AttachServiceRequestsStatusModal.constants'

import * as styles from './AttachServiceRequestsStatusModalFields.module.css'

function AttachServiceRequestsStatusModalFields({ checkboxLabel }) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const withStatusChange =
    values[ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS]

  return (
    <FormFieldsContainer>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t(checkboxLabel)}
        labelClassName={styles.checkboxLabel}
        labelTitleClassName={styles.checkboxLabelTitle}
        name={ATTACH_SERVICE_REQUESTS_STATUS_MODAL_FIELD_NAME_CHANGE_STATUS}
        qaName={QA_NAME_ATTACH_SERVICE_REQUESTS_STATUS_MODAL_CHECKBOX}
        size={CHECKBOX_SIZE.small}
        type={CHECKBOX_TYPE.action}
      />
      {withStatusChange ? <RequestEditStatusModalStatusField /> : null}
    </FormFieldsContainer>
  )
}

export default AttachServiceRequestsStatusModalFields
